import { MenuItem } from '@mui/material'
import { RestartTaskDialogV2 } from 'components/pages/task/details/task-content-v2/common/RestartTaskDialogV2'
import { TaskValue } from 'lib/actions/task'
import { useSimpleModal } from 'lib/modals'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type RestartTaskDropdownOptionProps = {
    task: TaskValue
    close: () => void
}

export const RestartTaskDropdownOption: FC<RestartTaskDropdownOptionProps> = ({ task, close }) => {
    const { open } = useSimpleModal()
    const handleClick = (): void => {
        open(RestartTaskDialogV2, { task })()
        close()
    }

    return (
        <MenuItem onClick={handleClick} key={`components_task_actions_dropdown_restart_task_${task.id}`}>
            <FormattedMessage id="components_task_actions_dropdown_restart_task" defaultMessage="Restart" />
        </MenuItem>
    )
}
